const clearLocalStorage = (storageType: string) => {
  localStorage.removeItem(storageType);
};

export { clearLocalStorage as default };
